<template>
  <div class="crumb">
    <el-tabs
      v-model="editableTabsValue"
      @tab-click="handleClick"
      @tab-remove="handleRemove"
    >
      <el-tab-pane
        v-for="(item, index) in crumbData"
        :key="item.menuId"
        :closable="index !== 0"
        :label="item.menuName"
        :name="item.menuId"
      />
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: "Crumb",
  mixins: [],
  data() {
    return {
      path: "",
      editableTabsValue: "",
      crumbData: [],
    };
  },
  mounted() {
    // console.log("this.$route.path", this.$route.path);
    this.crumbData = JSON.parse(sessionStorage.getItem("selectMenu")) || [];
    let menu = this.findMenuItemByPath(this.crumbData, this.$route.path);
    this.editableTabsValue = menu ? menu.menuId : "";
    this.$bus.$on("selectMenuItem", (val) => {
      this.crumbData = [...val.nodeList];
      this.editableTabsValue = val.node.menuId;
    });
  },
  methods: {
    findMenuItemByPath(menuList, path) {
      for (const menuItem of menuList) {
        // 如果当前菜单项的路径匹配，直接返回
        if (menuItem.menuLink === path) {
          return menuItem;
        }
        // 如果有子菜单，递归查找
        if (menuItem.children && menuItem.children.length > 0) {
          const foundItem = this.findMenuItemByPath(menuItem.children, path);
          if (foundItem) {
            return foundItem;
          }
        }
      }

      return null; // 未找到
    },
    handleClick(e) {
      const index = e.index;
      this.menuClick(this.crumbData[index]);
    },
    menuClick(node) {
      if (this.path === node.menuLink) {
        return;
      }
      this.path = node.menuLink;
      this.$router.push({
        path: this.path,
      });
    },
    handleRemove(targetId) {
      const tabs = this.crumbData;
      let activeName = this.editableTabsValue;
      // 如果删除的是当前激活的标签页
      if (activeName === targetId) {
        tabs.forEach((tab, index) => {
          if (String(tab.menuId) === targetId) {
            // 计算下一个应该激活的标签页索引
            const nextTab = tabs[index - 1] || tabs[index + 1];
            this.crumbData.splice(index, 1);
            if (nextTab) {
              activeName = String(nextTab.menuId);
              this.menuClick(nextTab);
            }
          }
        });
        this.editableTabsValue = activeName;
      } else {
        const index = this.crumbData.findIndex(
          (item) => item.menuId + "" === targetId
        );
        this.crumbData.splice(index, 1);
      }
      sessionStorage.setItem("selectMenu", JSON.stringify(this.crumbData));
    },
  },
};
</script>
<style scoped lang="scss">
.crumb {
  padding: 0.2rem 0.2rem 0 0.2rem;
  ::v-deep .el-tabs__item {
    height: auto;
    font-size: 0.14rem;
    line-height: 1;
    color: #8c8c8c;
    font-family: pr, serif;
    margin-right: 0;
    padding: 0.12rem 0.26rem 0.2rem 0.26rem;
    position: relative;
    ::after {
      content: "";
      width: 0.04rem;
      height: 0.04rem;
      border-radius: 50%;
      background-color: #8c8c8c;
      position: absolute;
      top: calc(50% - 0.04rem);
      left: 0.16rem;
      transform: translateY(-50%);
    }
  }
  ::v-deep .el-tabs__item.is-active {
    color: #1268ff;
    background: #fcfbff;

    border-radius: 0.08rem 0.08rem 0 0;
    border: none;
    border-top: 0.02rem solid #1268ff;
    position: relative;
    ::after {
      background-color: #1268ff;
    }
  }
  ::v-deep .el-tabs__item .el-icon-close {
    margin-left: 0.1rem;
    //position: absolute;
  }
  ::v-deep .el-tabs__nav-wrap {
    display: flex;
    align-items: center;
    margin-bottom: -0.08rem;
  }
  ::v-deep .el-tabs__nav-next,
  ::v-deep .el-tabs__nav-prev {
    height: 0.4rem;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    display: none;
  }
}
</style>
